module.exports = __webpack_public_path__ + "img/live_seminars_bg.321def13.png";